export default __webpack_public_path__ + "static/media/banner-05.9a477cee.png";